module.exports = __webpack_public_path__ + "static/oficina_privada.min-88ae7149870e7eea4acf4cdd2d47f3eb.png";